import { boolean, defineAction, enumerated, object, string } from '~/prix'
import monitorCourseClassesMetricsImportAction from './monitorCourseClassesMetricsImport.action.json'

const monitorCourseClassesMetricsImportDefinition = defineAction({
  ...monitorCourseClassesMetricsImportAction,
  input: object({
    file: string().isOptional(),
    step: enumerated({
      fetchUploadUrl: 'fetchUploadUrl',
      importFile: 'importFile',
    }),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default monitorCourseClassesMetricsImportDefinition
